import { useMemo, useState, type ReactNode } from 'react'
import { I18nContext, LANG_LABELS, type Dict, type I18nCtx, type Lang, useT } from './i18n-ctx'

export function I18nProvider({ dict, children }: { dict: Dict; children: ReactNode }) {
  const [lang, setLang] = useState<Lang>('en')
  const value = useMemo<I18nCtx>(
    () => ({
      lang,
      setLang,
      t: (key: string) => dict[key]?.[lang] ?? dict[key]?.en ?? key,
    }),
    [lang, dict],
  )
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function LangToggle() {
  const { lang, setLang } = useT()
  return (
    <div
      role="group"
      aria-label="Language"
      className="inline-flex items-center rounded-xl bg-ink-900/80 backdrop-blur border border-ink-800 p-1"
    >
      {(Object.keys(LANG_LABELS) as Lang[]).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 rounded-lg text-xs font-medium transition-colors ${
            lang === l ? 'bg-brand-600 text-white' : 'text-ink-100 hover:text-white'
          }`}
          aria-pressed={lang === l}
        >
          <span className="mr-1">{LANG_LABELS[l].flag}</span>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
